import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import CreateMessage from "../../components/Admin/Create-Message"

const Messages = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Messages | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <CreateMessage />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Messages
